module.exports = __webpack_public_path__ + "static/image-biersafe-l-403160d3629c81577f0bccc783e9cfb6.png";